// app-pages/PaymentsPage/CryptoPaymentsModal/queries/useCreatePayment.ts
"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { POST_CREATE_PAYMENT } from "api";

type PaymentDetails = {
  price_amount: number;
  price_currency: string;
  ipn_callback_url: string;
  order_id: string;
  order_description: string;
  success_url: string;
};

async function fetchCryptoPayment(details: PaymentDetails): Promise<any> {
  const response = await fetch(POST_CREATE_PAYMENT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(details),
  });

  return await response;
}

export default function useFetchCryptoPayment(
  price: number,
  plan: string,
  profileId?: string,
  opts = {}
) {
  const paymentDetails: PaymentDetails = {
    price_amount: price,
    price_currency: "usd",
    success_url: "https://deepmode.com/payments/success/crypto",
    ipn_callback_url: "https://api.deepmode.ai/payments/nowpayments_webhook",
    order_id: profileId || "",
    order_description: plan,
  };

  return useQuery<any, Error>({
    queryKey: ["createCryptoPayment", profileId, price, plan],
    queryFn: () => fetchCryptoPayment(paymentDetails),
    enabled: !!profileId && !!price && plan === "expert",
    ...opts,
  });
}
